import request from '@/utils/request'

let Supply_activityApi = {

  /*商会活动列表*/
  list(data) {
    return request._post('/shop/plus.supply_activity.Index/index', data);
},
audit(data) {
    return request._post('/shop/plus.supply_activity.Index/audit', data);
},
/*添加商会活动*/
add(data) {
    return request._post('/shop/plus.supply_activity.Index/add', data);
},
/*修改商会活动*/
edit(data) {
    return request._post('/shop/plus.supply_activity.Index/edit', data);
},
/*删除商会活动*/
del(data) {
    return request._post('/shop/plus.supply_activity.Index/del', data);
},
/*商会活动详情*/
detail(data) {
  return request._post('/shop/plus.supply_activity.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.supply_activity.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.supply_activity.Setting/getSetting', data, errorback);
    },
}
export default Supply_activityApi;



// WEBPACK FOOTER //
// ./src/api/supply_activity.js